module.exports = __webpack_public_path__ + "media/images/version_merge/steps_get_loan-5fdaf828a0438f900633114621d3ade3.jpg";